/**************************************************************************************
 *  Objetivo: Arquivo APP
 *  Autor: Luiz Gustavo
 *  Data: 12/01/2023
 *  Versão: 1.0
 **************************************************************************************/

import React from "react";
import RoutesApp from "./routes";
import './css/reset.css'

function App() {
  return (
      <RoutesApp />
  );
}

export default App;
